/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const dailyReportSchema = z.object({
  date: z.string(),
  passed: z.number(),
  failed: z.number(),
  skipped: z.number(),
  tried: z.number(),
  totalTimeSpent: z.number(),
  sessions: z.number(),
});

export type IDailyReport = z.infer<typeof dailyReportSchema>;
